module.exports = __webpack_public_path__ + "static/media/kor.01374782.svg";